import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=3e5d2568&scoped=true&"
import script from "./MultipleChoice.vue?vue&type=script&lang=js&"
export * from "./MultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=3e5d2568&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d2568",
  null
  
)

export default component.exports